import useMedia from 'react-use/lib/useMedia';

export const useDeviceType = () => {
  const desktop = useMedia('(min-width: 1100px)');
  const tablet = useMedia('(min-width: 768px) and (max-width: 1099px)');
  const phone = useMedia('(min-width: 320px) and (max-width: 767px)');
  const phoneLandscape = useMedia('(min-width: 320px) and (max-width: 768px)');

  return { phone, phoneLandscape, tablet, desktop };
}

export default useDeviceType;
